export const appFlowTypeEnum = {
  DEFAULT: 'DEFAULT',
  SIMPLE_WITH_WEB_REGISTRATION: 'SIMPLE_WITH_WEB_REGISTRATION',
  SIMPLE_WITHOUT_WEB_REGISTRATION: 'SIMPLE_WITHOUT_WEB_REGISTRATION',
};

export const appFlowModeEnum = {
  GENERAL_DEFAULT: 'generalDefault', // THREE_STEP
  TWO_STEP_DEFAULT: 'twoStepDefault', // REVERSE_PIN
  GENERAL_SIMPLE_WITH_WEB_REGISTRATION: 'generalSimpleWithWebRegistration', // TWO_STEP
  TWO_STEP_SIMPLE_WITH_WEB_REGISTRATION: 'twoStepSimpleWithWebRegistration',
  GENERAL_SIMPLE_WITHOUT_WEB_REGISTRATION: 'generalSimpleWithoutWebRegistration',
  TWO_STEP_SIMPLE_WITHOUT_WEB_REGISTRATION: 'twoStepSimpleWithoutWebRegistration', // ONLY_SMS
};
